module.exports = __webpack_public_path__ + "static/media/ua.55aaf64f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ua.svg
// module id = 2235
// module chunks = 0